
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacLazyImage from '@/components/BacLazyImage.vue'

import { Team } from '@/lib/models/Team'
import { StringUtils } from '../../lib/utils/StringUtils'

@Component({
  components: {
    BacLazyImage
  }
})
export default class BacTeamCard extends Vue {
  @Prop({ required: true }) private team!: Team;
  @Prop({ default: false }) private showVehicleImage!: boolean;
  @Prop({ required: true }) private defaultVehicleImage!: string;
  private iconSize = 0
  private loaded = true

  get logoImageUrl (): string {
    return this.team.logo ? (this.team.logo as any).filename
      : this.$store.state.PageURLRallyRound.rallyRound.defaultTeamLogoPath
  }

  get vehicleImageUrl (): string {
    let image = ''
    if (this.team.vehicles && this.team.vehicles.length) {
      this.team.vehicles.forEach(vehicle => {
        if (vehicle.imagePath) {
          image = vehicle.imagePath
        }
      })
      if (image) {
        return image
      }
    }
    // no vehicle image, just show default one
    this.loaded = true
    return this.defaultVehicleImage
  }

  get showLoadingSpinner (): boolean {
    // if there is an image but it should not be shown yet, show a loading spinner
    if (this.vehicleImageUrl && !this.showVehicleImage) {
      return true
    }
    return false
  }

  mounted () {
    this.calculateIconSize()
    window.addEventListener('resize', this.calculateIconSize)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.calculateIconSize)
  }

  private calculateIconSize () {
    this.iconSize = (this.$el as HTMLElement).offsetWidth / 6
    if (this.iconSize > 100) {
      this.iconSize = 100
    }
  }
}
